import { LockIcon } from '../../assets/Icons';

function PaymentInfo() {
  return (
    <div className="flex items-center gap-x-1 px-3 py-1.5 border border-up-green-50 rounded-xl text-up-green-50 bg-up-green-10 text-xs font-normal mt-5 mx-auto w-max">
      <LockIcon className="text-up-green-50" />
      <span>Your payment information is secure and encrypted</span>
    </div>
  );
}

export default PaymentInfo;
